export default __webpack_public_path__ + "static/media/ed2mit2021tuto02_dmg-dmbok-orgroles-v03.636e31d9.pdf";